var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(_vm._s(_vm.$t('refs')))]),_c('v-expansion-panel-content',[_c('p',[_vm._v(_vm._s(_vm.references))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }